export default "__VITE_ASSET__dadc2756__"